export default "__VITE_ASSET__TSb1B7aH__"